import type { UseFetchOptions } from 'nuxt/app'
import { useLogger } from './useLogger'
import { useApiService } from './useApiService'


export interface WelcomeRequest {
    recipientEmail: string
    recipientName: string
}

export interface WelcomeResponse {
    success: boolean
    version: number
    message: string
    recipientEmail: string
    recipientName: string
    environment: string
    timestamp: string
    process: {
        type: string
        nodeVersion: string
        platform: string
    }
}

export function useWelcomeService() {
    const logger = useLogger()
    const { makeApiCall, forceTestVsTestServer } = useApiService()

    const sendWelcome = async (recipientName: string, recipientEmail: string, options?: UseFetchOptions<WelcomeResponse>) => {
        logger.debug('WelcomeService: Sending welcome', { recipientName })

        const welcomeRequest: WelcomeRequest = {
            recipientName: recipientName,
            recipientEmail: recipientEmail
        }

        return makeApiCall<WelcomeRequest, WelcomeResponse>(
            'sendwelcome',
            welcomeRequest,
            'WelcomeService',
            options
        )
    }

    const sendTestWelcome = async (recipientName: string, recipientEmail: string, forceTestVsTestServerInput = false) => {
        forceTestVsTestServer.value = forceTestVsTestServerInput
        const welcomeRequest: WelcomeRequest = {
            recipientName: recipientName,   
            recipientEmail: recipientEmail
        }

        return makeApiCall<WelcomeRequest, WelcomeResponse>(
            'sendwelcome',
            welcomeRequest,
            'WelcomeService',
            null
        )
    }

    return {
        forceTestVsTestServer,
        sendWelcome,
        sendTestWelcome
    }
} 